module.exports = __webpack_public_path__ + "logo-da.svg?75042c31db76fe42de051427a7231552";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-da.svg
// module id = 185
// module chunks = 0